import { type FC } from 'react';

import { type QuickLinksProps } from '../../types';
import { QuickLinkItem } from '../QuickLinkItem';

import styles from './QuickLinksList.css';

export const QuickLinksList: FC<QuickLinksProps> = ({ quickLinks, trackQuickLinkClick }) => {
  return (
    <ul className={styles['list']} data-testid="quick-links.list">
      {quickLinks.map(link => (
        <li className={styles['item']} data-testid="quick-links.list-item" key={link.id}>
          <QuickLinkItem
            offersCount={link.offersCount}
            paddingLink={8}
            title={link.title}
            track={(): void => trackQuickLinkClick(link)}
            url={link.url}
          />
        </li>
      ))}
    </ul>
  );
};
